import React, { FC, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import text from 'styles/utility/text.module.scss'
import { closeModal } from 'reducks/modal/operations'
import { push } from 'connected-react-router'

const IndividualScheduleCaution: FC = () => {
  const dispatch = useDispatch()
  const goToBusinessHourPage = useCallback(() => {
    dispatch(push('/account/settings'))
    dispatch(closeModal())
  }, [])

  return (
    <div className={`${text.font_small} ${text.font_bold}`}>
      <p className={text.color_caution}>
        選択した日にちは、定休日・臨時休業日に設定されているため個別日の設定ができません。
        お店を臨時営業日に設定してから再度設定してください。
      </p>
      <a className={text.color_blue_main} onClick={goToBusinessHourPage} role={'button'}>
        商品の受け渡しに関する設定はこちらから
      </a>
    </div>
  )
}

export default IndividualScheduleCaution
